import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './css/index.css';
import "./assets/css/bootstrap.css"
import "./assets/css/style.css"
import "./css/loadspiner.css"
import { createBrowserRouter, RouterProvider, } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from "react-query";
import styled from 'styled-components';

const App = lazy(() => import('./App'));
const JobDetail = lazy(() => import('./jobdetail'));
const ErrorPage = lazy(() => import('./error-page'));

const queryClient = new QueryClient();
const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorPage />,
  },
  {
    path: "jobdetail/:jobdetailId",
    element: <JobDetail />,
  }
]);

export const LoadSpinner = styled.div`
  height: 100dvh;
  display: flex;
  justify-content: center;
  align-items: center;

  .loader {
    border: 4px solid #f3f3f3;
    border-top: 4px solid #ff9b44;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
  
    100% {
      transform: rotate(360deg);
    }
  }
`;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <QueryClientProvider client={queryClient}>
    <Suspense fallback={
      <LoadSpinner>
          <div className="loader">
            Loading....
          </div>
        </LoadSpinner>
    }>
      <RouterProvider router={router} />
    </Suspense>
  </QueryClientProvider>
);
